import {TabState, TabStateDefaults} from 'Navigation';

export default class GenerativeModelsTabState extends TabState {
  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Generative Models',
      closeable: false,
      preferenceKey: 'generative-models',
    };
  }
}
